<template>
  <div class="pb-4">
    <h3
      id="modal-headline"
      class="py-2 text-lg leading-6 font-medium text-gray-900"
    >
      Future Purchase Orders for Inventory Item <br> {{ sku }}
    </h3>
    <div class="py-2" style="height: 400px;">
      <ag-grid-vue
        style="height: 100%; width: 100%;"
        class="ag-theme-balham"
        :columnDefs="columnDefs"
        :rowData="rowData"
        :paginationAutoPageSize="false"
        :paginationPageSize="paginationPageSize"
        :pagination="true"
        id="inventory-available"
        :gridOptions="gridOptions"
        @grid-ready="onGridReady"
        @first-data-rendered="onFirstDataRendered"
        :context="context"
        :frameworkComponents="frameworkComponents"
        :defaultColDef="defaultColDef"
        :enableCellTextSelection="true"
        :ensureDomOrder="true"
      >
      </ag-grid-vue>
    </div>
  </div>
</template>

<script>
import { AgGridVue } from "ag-grid-vue";
import { ApiFactory } from "@/api/ApiFactory.js";

const InventoriesApi = ApiFactory.get("inventories");

export default {
  name: "QuantityOnHand",
  components: {
    AgGridVue
  },
  props: {
    sku: String
  },
  data() {
    return {
      columnDefs: null,
      rowData: null,
      paginationPageSize: 100,
      frameworkComponents: null,
      gridApi: null,
      columnApi: null,
      gridOptions: null,
      context: null,
      defaultColDef: null,
      overlayLoadingTemplate: true
    };
  },
  beforeMount() {
    this.gridOptions = {};

    this.context = { componentParent: this };

    this.defaultColDef = {
      sortable: true,
      suppressMovable: true
    };

    this.columnDefs = [
      {
        headerName: "Counter",
        field: "Counter",
        type: "rightAligned",
      },
      {
        headerName: "Unit Cost",
        field: "UnitCost",
        type: "rightAligned",
        valueFormatter(params) {
          return Number(params.value).toFixed(2);
        },
      },
      {
        headerName: "Remaining Q",
        field: "RemainingQ",
        type: "rightAligned",
      },
      {
        headerName: "Total Cost",
        field: "TotalCost",
        type: "rightAligned",
        valueFormatter(params) {
          return Number(params.value).toFixed(2);
        },
      },
    ];

    InventoriesApi.fifo(this.sku)
      .then(response => {
        this.rowData = response.data.body.map(row => {
          return {
            Counter: row.Counter,
            UnitCost: row.UnitCost,
            RemainingQ: row.RemainingQ,
            TotalCost: row.TotalCost,
          };
        });
      });
  },
  mounted() {
    this.gridApi = this.gridOptions.api;
    this.gridColumnApi = this.gridOptions.columnApi;
  },
  methods: {
    onFirstDataRendered(params) {
      params.api.sizeColumnsToFit();
    },
    onGridReady() {}
  },
};
</script>
<style lang="scss">
@import "../../../../../node_modules/ag-grid-community/dist/styles/ag-grid.css";
@import "../../../../../node_modules/ag-grid-community/dist/styles/ag-theme-balham.css";
</style>
